import styled from 'styled-components'
import Description from '../../components/Description/Description'
import Title from '../../components/Title/Title'
import softpedia from '../../images/reviews/softpedia.jpg'
import user from '../../images/reviews/user.jpg'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`
const Grid1 = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 50px;
  width: 100%;
`
const Grid4 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  grid-gap: 50px;
`
const Card = styled.div`
  border-radius: 10px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 25px;
  height: 300px;

  &.first-user {
    background: url(${softpedia});
    background-size: cover;
  }
  &.second-user {
    background: url(${user});
    background-size: cover;
  }
  &.third-user {
    background: url(${softpedia});
    background-size: cover;
  }
  &.fourth-user {
    background: url(${user});
    background-size: cover;
  }
`
const Quote = styled.q``
const Author = styled.span`
  margin-top: 25px;
  font-size: 14px;
`

export default function Users() {
  return (
    <Container>
      <div className="container">
        <Wrapper>
          <Grid1>
            <Title title="Join over 30,000 users!" />
            <Description description="Thousands of users around the world use GDark for their work or hobby, to save their eyes, or to write better. Be one of them now!" />
            <Grid4>
              <Card className="first-user">
                <Quote>
                  GDark is the best dark mode extension I've used.
                </Quote>
                <Author>Alexandra Petrache, Softpedia</Author>
              </Card>
              <Card className="second-user">
                <Quote>
                  Now that I spend more than an hour with grammarly, my eyes can
                  actually rest.
                </Quote>
                <Author>Mostafa Ranjbar, User</Author>
              </Card>
              <Card className="third-user">
                <Quote>It arguably makes the writing experience look a lot cooler.</Quote>
                <Author>Vladimir Ciobica, Softpedia</Author>
              </Card>
              <Card className="fourth-user">
                <Quote>I prefer everything dark, so this really helped.</Quote>
                <Author>Shannon McCarthy, User</Author>
              </Card>
            </Grid4>
          </Grid1>
        </Wrapper>
      </div>
    </Container>
  )
}
